import axios from 'axios';
import { finishLoading, startLoading } from '../store/actions/loading';
import { AUTH } from '../constants';
import { getLocalData } from '../helpers/localStore';

let baseURL;

if (process.env.NODE_ENV === 'production') {
  baseURL = '/api/v1';
} else {
  baseURL = process.env.REACT_APP_BASE_API_URL_DEV;
}

const API = axios.create({
  baseURL,
});

const APIInterceptor = (store) => {
  try {
    // Request interceptors
    API.interceptors.request.use(
      (conf) => {
        if (conf.method !== 'get' || conf.headers?.showOverlay) {
          store.dispatch(startLoading());
        }

        // Add JWT token
        const auth = getLocalData(AUTH);

        if (auth) {
          conf.headers.Authorization = `Bearer ${auth.token}`;
        }

        return conf;
      },
      (error) => {
        store.dispatch(finishLoading());

        return Promise.reject(error);
      }
    );
    API.interceptors.response.use(
      (res) => {
        return new Promise((resolve) => {
          setTimeout(() => {
            store.dispatch(finishLoading());
            return resolve(res?.data);
          }, 300);
        });
      },
      (error) => {
        store.dispatch(finishLoading());
        return Promise.reject(
          error?.response?.data
            ? error.response.data
            : {
                message:
                  'Ocurrio un error inesperado, favor revise su conexión',
              }
        );
      }
    );
  } catch (error) {
    console.log(error);
  }
};

export { API, APIInterceptor };
